var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 5a1 1 0 011 1v10a1 1 0 01-1 1h-2v2a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1h2V6a1 1 0 011-1h10zM8 9H6v10h10v-2H9a1 1 0 01-1-1V9zm11-3H9v10h10V6z"
  })));
});
export default SvgCopy;